import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import IWorkflowBasicInfo from "../interface/trade/IWorkflowBasicInfo";
import IQueryTradesBasicInfo from "../queryStrings/IQueryTradesBasicInfo";

enum TradeDisbursementServiceEnum {
  searchByStatus = "/search?",
  returnToReady = "/re-run",
  confirmedDisbursement = "/confirmend",
  setFailure = "/set-failure",
  moveToReady = "/move-to-ready"
}

export default class TradeDisbursementService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/disbursement");
  }

  public getTradesDisbursementBasicInfo =
    async (status: string, queryString: IQueryTradesBasicInfo): Promise<IWorkflowBasicInfo> =>
      await this.POST(TradeDisbursementServiceEnum.searchByStatus + "status=" + status, queryString);

  public returnToReady = async (tradeId: number, reason: string) => {
    const data = this.POST(TradeDisbursementServiceEnum.returnToReady + `?tradeId=${tradeId}&reason=${reason}`, null);

    return data;
  };

  public setFailure = async (tradeId: number, reason: string, tedReturnedMarkedManually: boolean) => {
    const data = this.POST(TradeDisbursementServiceEnum.setFailure + `?tradeId=${tradeId}&reason=${reason}&tedReturnedMarkedManually=${tedReturnedMarkedManually}`, null);

    return data;
  };

  public moveToReady = async (tradeId: number, isTradeConvenio: boolean) => {

    const data = this.POST(TradeDisbursementServiceEnum.moveToReady + `?tradeId=${tradeId}&isTradeConvenio=${isTradeConvenio}`, null);

    return data;
  };

  public confirmedDisbursement = async (tradeId: number, reason: string) => {
    const data = this.POST(TradeDisbursementServiceEnum.confirmedDisbursement + `?tradeId=${tradeId}&reason=${reason}`, null);
    return data;
  };
}



// WEBPACK FOOTER //
// ./src/services/api/TradeDisbursement.service.ts